import { useEffect, useRef } from 'react';

export function useIsMounted() {
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  return isMounted;
}

/**
 * Hook that logs when a component mounts and unmounts.
 * Useful for debugging component lifecycle.
 *
 * @param componentName - Optional name to identify the component in logs
 * @example
 * ```tsx
 * function MyComponent() {
 *   useDebugMount('MyComponent');
 *   return <div>Hello</div>;
 * }
 * ```
 */
export function useDebugMount(componentName?: string) {
  useEffect(() => {
    const name = componentName || 'Component';
    console.log(`[Mount] ${name}`);

    return () => {
      console.log(`[Unmount] ${name}`);
    };
  }, [componentName]);
}
